import * as React from "react";
import { Box, Typography } from "@mui/material";

interface CustomModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  fullWidth?: boolean;
}

export default function CustomModal({
  open,
  onClose,
  title,
  children,
  actions,
  maxWidth = "md",
  fullWidth = true,
}: CustomModalProps) {
  React.useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && open) onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <Box
      sx={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1300, p: 2 }}
      onClick={onClose}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
          maxWidth: maxWidth === "xs" ? 344 : maxWidth === "sm" ? 400 : maxWidth === "md" ? 600 : maxWidth === "lg" ? 960 : 1280,
          width: fullWidth ? "100%" : "auto",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ backgroundColor: "#212529", color: "#ffffff", padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: "1rem" }}>{title}</Typography>
          <Box onClick={onClose} sx={{ cursor: "pointer", fontSize: "1.25rem", color: "#ffffff", lineHeight: 1, "&:hover": { opacity: 0.7 } }}>×</Box>
        </Box>
        <Box sx={{ padding: "16px", overflowY: "auto", flex: 1 }}>{children}</Box>
        {actions && (
          <Box sx={{ padding: "12px 16px", borderTop: "1px solid #e5e7eb", display: "flex", justifyContent: "flex-end", gap: 1 }}>
            {actions}
          </Box>
        )}
      </Box>
    </Box>
  );
}
